import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IMarket } from '../../shared/models/market.model';
import { HttpService } from '../../shared/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class MarketsLookupService {
  private readonly marketsUrl = '/markets';

  constructor(private http: HttpService<IMarket>) {}

  /**
   * Get markets
   * @returns {IMarket} Markets list
   * @public
   */
  getMarkets(): Observable<IMarket[]> {
    return this.http.get(this.marketsUrl);
  }
}
